import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { sql } from '@codemirror/lang-sql';
import { oneDark } from '@codemirror/theme-one-dark';

export type CodeEditorProps = {
  value: string;
  onChange: (val: string) => void;
  language?: 'sql' | 'text';
  theme?: 'light' | 'dark';
  height?: string | number;
  style?: React.CSSProperties;
  className?: string;
  placeholder?: string;
  schema?: Record<string, any>;
};

export default function CodeEditor({ value, onChange, language = 'sql', theme = 'light', height = '240px', style, className, placeholder, schema }: CodeEditorProps) {
  const extensions = React.useMemo(() => {
    const exts: any[] = [];
    if (language === 'sql') exts.push(sql({ schema: schema as any }));
    return exts;
  }, [language, schema]);

  const containerStyle: React.CSSProperties = {
    border: '1px solid #e5e7eb',
    borderRadius: 6,
    overflow: 'hidden',
    ...style,
  };

  return (
    <div className={className} style={containerStyle}>
      <CodeMirror
        value={value || ''}
        height={typeof height === 'number' ? `${height}px` : height}
        theme={theme === 'dark' ? oneDark : undefined}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLine: true,
          highlightActiveLineGutter: true,
          autocompletion: true,
          foldGutter: true,
          syntaxHighlighting:true,
        } as any}
        extensions={extensions}
        onChange={(val) => onChange(val)}
        placeholder={placeholder}
      />
    </div>
  );
}
